/* Tymzo Ajax Cart V17 — sans livraison gratuite */

(() => {

  'use strict';

  const root = document.querySelector('[data-tymzo-cart]');

  if (!root) return;

  const content = root.querySelector('[data-tymzo-cart-content]');

  const footer = root.querySelector('[data-tymzo-cart-footer]');

  const total = root.querySelector('[data-tymzo-cart-total]');
  const cartUrl = root.dataset.cartUrl || '/cart';

  const cartJsonUrl = root.dataset.cartJsonUrl || '/cart.js';

  const addUrl = root.dataset.cartAddUrl || '/cart/add';

  const changeUrl = root.dataset.cartChangeUrl || '/cart/change';
  let lastFocus = null;

  let busy = false;


  let mapValid = false;

  const money = cents => {

    try {

      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {

        style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'

      }).format(cents / 100);

    } catch { return `${(cents / 100).toFixed(2)} €`; }

  };

  const escapeHtml = value => {

    const el = document.createElement('div');

    el.textContent = String(value ?? '');

    return el.innerHTML;

  };

  const openCart = () => {

    lastFocus = document.activeElement;

    root.classList.add('is-open');

    root.setAttribute('aria-hidden', 'false');

    document.body.classList.add('tymzo-cart-open');

    window.setTimeout(() => root.querySelector('[data-tymzo-cart-close]')?.focus(), 50);

  };

  const closeCart = () => {

    root.classList.remove('is-open');

    root.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('tymzo-cart-open');

    lastFocus?.focus?.();

  };

  const itemMarkup = (item, index) => {

    const variant = item.variant_title && item.variant_title !== 'Default Title'

      ? `<p class="tymzo-ajax-cart__variant">${escapeHtml(item.variant_title)}</p>` : '';

    const image = item.image

      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';

    return `<article class="tymzo-ajax-cart__item" data-tymzo-cart-line data-line="${index + 1}">

      <a href="${escapeHtml(item.url)}" class="tymzo-ajax-cart__image">${image}</a>

      <div class="tymzo-ajax-cart__item-content">

        <div class="tymzo-ajax-cart__item-top"><div><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>${variant}</div>

          <button type="button" class="tymzo-ajax-cart__remove" data-tymzo-cart-remove aria-label="Retirer ${escapeHtml(item.product_title)}">

            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16"></path><path d="M9 7V4h6v3"></path><path d="M7 7l1 13h8l1-13"></path></svg>

          </button></div>

        <div class="tymzo-ajax-cart__item-bottom"><div class="tymzo-ajax-cart__quantity">

          <button type="button" data-tymzo-cart-minus aria-label="Diminuer la quantité">−</button>

          <input type="number" min="0" value="${item.quantity}" data-tymzo-cart-quantity aria-label="Quantité de ${escapeHtml(item.product_title)}">

          <button type="button" data-tymzo-cart-plus aria-label="Augmenter la quantité">+</button>

          </div><p class="tymzo-ajax-cart__line-price">${money(item.final_line_price)}</p></div>

      </div></article>`;

  };

  const emptyMarkup = () => `<div class="tymzo-ajax-cart__empty"><span aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"></path><path d="M9 8V6a3 3 0 0 1 6 0v2"></path></svg></span>

    <h3>Votre panier est vide</h3><p>Découvrez notre sélection pour vous sentir bien au quotidien.</p>

    <a href="/collections/all" class="tymzo-ajax-cart__continue">Découvrir la boutique</a></div>`;

  const renderCart = cart => {

    if (!content || !footer || !total) return;

    content.innerHTML = cart.item_count > 0

      ? `<div class="tymzo-ajax-cart__items">${cart.items.map(itemMarkup).join('')}</div>` : emptyMarkup();

    footer.hidden = cart.item_count === 0;

    total.textContent = money(cart.total_price);
    document.querySelectorAll('[data-cart-count], .cart-count-bubble, [data-cart-bubble]')

      .forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });

    document.dispatchEvent(new CustomEvent('tymzo:cart:updated', { detail: { cart } }));

  };

  const getCart = async () => {

    const separator = cartJsonUrl.includes('?') ? '&' : '?';

    const response = await fetch(`${cartJsonUrl}${separator}\\_=${Date.now()}`, {

      headers: { Accept: 'application/json' }, cache: 'no-store'

    });

    if (!response.ok) throw new Error('Impossible de charger le panier.');

    return response.json();

  };

  const refreshCart = async (open = false) => {

    const cart = await getCart();
    renderCart(cart);

    if (open) openCart();

    return cart;

  };

  const changeLine = async (line, quantity) => {

    if (busy) return;

    busy = true;

    try {

      const response = await fetch(`${changeUrl}.js`, {

        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

        body: JSON.stringify({ line, quantity })

      });

      if (!response.ok) throw new Error('Impossible de modifier le panier.');

      await refreshCart();

    } catch (error) { console.error('[Tymzo Cart]', error); }

    finally { busy = false; }

  };

  const addForm = async form => {

    if (busy) return;

    busy = true;

    const button = form.querySelector('[type="submit"], [name="add"]');

    const originalText = button?.textContent;

    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Ajout en cours...'; }

    try {

      const response = await fetch(`${addUrl}.js`, {

        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)

      });

      if (!response.ok) {

        const error = await response.json().catch(() => ({}));

        throw new Error(error.description || 'Impossible d’ajouter ce produit.');

      }

      await refreshCart(true);

    } catch (error) { console.error('[Tymzo Cart]', error); window.alert(error.message); }

    finally {

      busy = false;

      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = originalText; }

    }

  };

  document.addEventListener('submit', event => {

    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form) return;

    event.preventDefault();

    addForm(form);

  });

  root.addEventListener('click', event => {

    if (event.target.closest('[data-tymzo-cart-close]')) { closeCart(); return; }

    const row = event.target.closest('[data-tymzo-cart-line]');

    if (!row) return;

    const line = Number(row.dataset.line);

    const input = row.querySelector('[data-tymzo-cart-quantity]');

    const quantity = Number(input?.value || 1);

    if (event.target.closest('[data-tymzo-cart-minus]')) changeLine(line, Math.max(0, quantity - 1));

    else if (event.target.closest('[data-tymzo-cart-plus]')) changeLine(line, quantity + 1);

    else if (event.target.closest('[data-tymzo-cart-remove]')) changeLine(line, 0);

  });

  root.addEventListener('change', event => {

    const input = event.target.closest('[data-tymzo-cart-quantity]');

    if (!input) return;

    const row = input.closest('[data-tymzo-cart-line]');

    if (row) changeLine(Number(row.dataset.line), Math.max(0, Number(input.value || 0)));

  });

  document.addEventListener('click', async event => {

    const trigger = event.target.closest('[data-tymzo-cart-open], [aria-controls="TymzoAjaxCart"], [aria-controls="cart-drawer"], a[href="/cart"], a[href*="/cart"]');

    if (!trigger || trigger.closest('[data-tymzo-cart]')) return;

    event.preventDefault();

    try { await refreshCart(true); }

    catch (error) { console.error('[Tymzo Cart Open]', error); window.location.href = cartUrl; }

  });

  document.addEventListener('cart:refresh', async () => {

    try { await refreshCart(true); }

    catch (error) { console.error('[Tymzo Cart Refresh]', error); }

  });

  document.addEventListener('keydown', event => {

    if (event.key === 'Escape' && root.classList.contains('is-open')) closeCart();

  });

  // Ne pas reconstruire un panier à partir du sous-total formaté.

  // Le vrai panier est récupéré depuis Shopify.

  refreshCart().catch(error => { console.warn('[Tymzo Cart] Initialisation :', error); });

})();
